import { useSSRData } from 'hooks';
import { getFeatureFlagsData } from 'utils';
import getFirstCorrectData from './utils';

const useFeatureFlagsData = () => {
    // eslint-disable-next-line camelcase
    const { featureFlags_abTests } = useSSRData();
    return getFirstCorrectData(featureFlags_abTests, getFeatureFlagsData(), {});
};
export default useFeatureFlagsData;
